// extracted by mini-css-extract-plugin
export var bottomMenu = "style-module--bottomMenu--018e6";
export var categories = "style-module--categories--a6d9b";
export var icon = "style-module--icon--a7e09";
export var icons = "style-module--icons--0c79d";
export var item = "style-module--item--09c66";
export var label = "style-module--label--7d2f3";
export var languageSwitch = "style-module--languageSwitch--7ac0f";
export var link = "style-module--link--6b44e";
export var links = "style-module--links--2e540";
export var list = "style-module--list--4c24b";
export var main = "style-module--main--a9055";
export var menu = "style-module--menu--acfd2";
export var modalCover = "style-module--modalCover--9c6f8";
export var othersMenu = "style-module--othersMenu--43835";
export var sns = "style-module--sns--513b6";
export var special = "style-module--special--084b5";